/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Track_Status_Table_LabelInputs */

const en_work_order_publish_track_status_table_label = /** @type {(inputs: Work_Order_Publish_Track_Status_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track Status Table`)
};

const fr_work_order_publish_track_status_table_label = /** @type {(inputs: Work_Order_Publish_Track_Status_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de statut des pistes`)
};

const de_work_order_publish_track_status_table_label = /** @type {(inputs: Work_Order_Publish_Track_Status_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track-Statustabelle`)
};

const it_work_order_publish_track_status_table_label = /** @type {(inputs: Work_Order_Publish_Track_Status_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabella dello stato della traccia`)
};

const ru_work_order_publish_track_status_table_label = /** @type {(inputs: Work_Order_Publish_Track_Status_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Таблица статуса отслеживания`)
};

const es_work_order_publish_track_status_table_label = /** @type {(inputs: Work_Order_Publish_Track_Status_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabla de estado de la pista`)
};

const zh_cn2_work_order_publish_track_status_table_label = /** @type {(inputs: Work_Order_Publish_Track_Status_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跟踪状态表`)
};

const ja_work_order_publish_track_status_table_label = /** @type {(inputs: Work_Order_Publish_Track_Status_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラックステータステーブル`)
};

const hi_work_order_publish_track_status_table_label = /** @type {(inputs: Work_Order_Publish_Track_Status_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैक स्थिति तालिका`)
};

const pt_pt2_work_order_publish_track_status_table_label = /** @type {(inputs: Work_Order_Publish_Track_Status_Table_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabela de status da faixa`)
};

/**
* | output |
* | --- |
* | "Track Status Table" |
*
* @param {Work_Order_Publish_Track_Status_Table_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_track_status_table_label = /** @type {((inputs?: Work_Order_Publish_Track_Status_Table_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Track_Status_Table_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_track_status_table_label(inputs)
	if (locale === "de") return de_work_order_publish_track_status_table_label(inputs)
	if (locale === "it") return it_work_order_publish_track_status_table_label(inputs)
	if (locale === "ru") return ru_work_order_publish_track_status_table_label(inputs)
	if (locale === "es") return es_work_order_publish_track_status_table_label(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_track_status_table_label(inputs)
	if (locale === "ja") return ja_work_order_publish_track_status_table_label(inputs)
	if (locale === "hi") return hi_work_order_publish_track_status_table_label(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_track_status_table_label(inputs)
	return en_work_order_publish_track_status_table_label(inputs)
});